module.exports = __webpack_public_path__ + "static/media/twilio.027604ec.svg";